import { forwardRef, useId } from "react";
import type { IconsaxProps } from "./Iconsax.types.js";

export const ToRightArrowBold = forwardRef<HTMLDivElement, IconsaxProps>(({ size = 24, color = "currentColor", ...rest }, ref) => {
    const clipId = useId();
    return (
        <div ref={ref} {...rest} style={{ display: "flex", width: "fit-content", alignItems: "center", justifyContent: "center", ...rest.style }}>
            <svg width={size} height={size} viewBox="0 0 24 24" fill={color} xmlns="http://www.w3.org/2000/svg">
                <g clipPath={`url(#${clipId})`}>
                    <path d="M22.28 10.5897L14.78 3.1697C14.57 2.9597 14.24 2.88969 13.96 3.00969C13.68 3.12969 13.5 3.3997 13.5 3.6997V7.0997C10.28 7.1797 7.65995 7.7497 5.69995 8.8097C2.90995 10.3097 1.5 12.7297 1.5 16.0197V20.2897C1.5 20.6297 1.73996 20.9397 2.07996 21.0197C2.13996 21.0297 2.2 21.0397 2.25 21.0397C2.53 21.0397 2.79004 20.8797 2.92004 20.6197C5.39004 15.6797 11.49 15.2997 13.5 15.3397V18.6997C13.5 19.0097 13.69 19.2797 13.97 19.3997C14.25 19.5097 14.57 19.4497 14.79 19.2297L22.29 11.6597C22.42 11.5097 22.5 11.3197 22.5 11.1197C22.5 10.9197 22.42 10.7397 22.28 10.5897Z" />
                </g>
                <defs>
                    <clipPath id={clipId}>
                        <rect width="24" height="24" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        </div>
    );
});
